import { ContactFormState } from "../interfaces/contactUs_type";
import { API, APIResponse } from "../components/_Shared/API/API";
import { CREATE_CONTACT_US, GET_CONTACT_US, CONTACT_MARK_AS_SEEN } from "./Endpoints/contact_us";

export async function SendContactUsForm(obj: ContactFormState & {recaptcha: string}): Promise<APIResponse<ContactFormState>> {
    const response = await API.post<ContactFormState>(CREATE_CONTACT_US, obj)
    return response
}

export async function GetContactUs(): Promise<APIResponse<ContactFormState[]>> {
    const response = await API.get<ContactFormState[]>(GET_CONTACT_US)
    return response
}

export async function MarkAsSeen(email: string): Promise<APIResponse<ContactFormState>> {
    const response = await API.put<ContactFormState>(CONTACT_MARK_AS_SEEN, {email})
    return response
}
